const TASK_TYPE = ['listening', 'multiple_choice', 'speaking'] as const
type ITaskType = (typeof TASK_TYPE)[number]

export { TASK_TYPE }
export type { ITaskType }
